import { apiUrl } from '../utils/constants';
import { DELETE, GET, POST, PUT } from './api.service.wrapper';


export const UpdateContents = async (id, data) => {
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }
    const response = await PUT(apiUrl.contents, id, data, config);
    return response;
}


export const GetContents = async (keyword = '', page = '', perPage = '', is_paginate = 1, status = null) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per-page'] = perPage;
    }

    if (keyword) {
        params['keyword'] = keyword;
    }

    if (status) {
        params['status'] = status;
    }

    params['is_paginate'] = is_paginate;
    const response = await GET(apiUrl.contents, params);
    return response;
}

export const GetContentById = async (id) => {
    let response = '';
    response = await GET(apiUrl.contents + '/' + id);
    return response;
}

export const CreateContent = async (data) => {
    const response = await POST(apiUrl.contents, data);
    return response;
}

export const UpdateContent = async (id, data) => {
    const response = await PUT(apiUrl.contents, id, data);
    return response;
}

export const DeleteContent = async (id) => {
    const response = await DELETE(apiUrl.contents, id);
    return response;
}
